import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/forgotpassword.css';
import Nav from '../components/nav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  async function resetPW(){
    const resetEmail = await fetch(`${baseUrl}/forgotPassword`, {
      method: "POST",
      headers : {"Content-Type": "application/json"},
      body : JSON.stringify({
        email: email
      })
    });
    if (!resetEmail.ok) throw new Error(`forgotPassword failed (${resetEmail.status})`);
  }

  async function emailTest(){
    const resetEmail = await fetch(`${baseUrl}/getUserByEmail`, {
      headers: {
        email: email,
      },
    });
    if (!resetEmail.ok) throw new Error(`getUserByEmail failed (${resetEmail.status})`);
    const data = await resetEmail.json();
    return data;
  }

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    // Reset previous messages
    setMessage('');
    setError('');

    if (!email) {
      setError('Email is required');
      return;
    }    

    try {
      const accountExists = await emailTest();
      if (accountExists) await resetPW();
      // Same message whether or not the account exists (no account enumeration).
      setMessage('If an account exists for this email, a reset link has been sent.');
    } catch (err) {
      setError('Something went wrong sending the reset link. Please try again later.');
    }
  };

  return (
    <>
      <SEO
        title="Forgot Password"
        description="Reset your ProducerBuddy account password to regain access to your film production tools and projects."
        url="https://producerbuddy.pilomation.com/forgot-password"
        robots="noindex, nofollow"
      />
      <Nav/>
      <div className="forgot-password-container">
        <h1 className="forgot-password-title">Forgot Password</h1>
        <form className="forgot-password-form" onSubmit={handleForgotPassword}>
          <div className="form-group">
            <label htmlFor="email">Enter your email address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email Address"
              required
            />
            {error && <p className="error-text">{error}</p>}
          </div>
          <button type="submit" className="reset-button">Send Reset Link</button>
          {message && <p className="success-text">{message}</p>}
        </form>
        <div className="forgot-password-footer">
          <p><Link to="/login">Back to Login</Link></p>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;

